export const LOGO="https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png"
export const USER_AVATAR="https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg"
export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwOWEzYzVjOGY0OTE3MTI1Mzk2NTVkNGNjNjg2OTRiMiIsInN1YiI6IjYzZTNlYjY0ZmFjNTAyMDA3YzVhMGVkMCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.OBJPDq3BPyiiDOP4fhG8FlJJiApHzOVgbW9mJ6HJe70'
    }
  };
  export const CDN_LINK="https://image.tmdb.org/t/p/w500/"
  export const SUPPORTED_LANGUAGES=[{identifier:"en",value:"English"},{identifier:"Hindi",value:"Hindi"},{identifier:"Spanish",value:"Spanish"}]
  export const BG_IMG="https://assets.nflxext.com/ffe/siteui/vlv3/4da5d2b1-1b22-498d-90c0-4d86701dffcc/98a1cb1e-5a1d-4b98-a46f-995272b632dd/IN-en-20240129-popsignuptwoweeks-perspective_alpha_website_small.jpg"